<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <div class="d-flex flex-row justify-content-between">
        <div>
          <h1>{{ info.storeName }}</h1>
        </div>
        <div style="gap: 10px" class="d-flex">
          <b-button variant="outline-primary" @click="onUpdate" class="hc-37 pt-2">
            Cập nhật
          </b-button>
          <button type="button" @click="ReturnToList" class="btn btn-outline-secondary hc-37 pt-2">
            <i class="bx bx-arrow-back"></i>
            <span>&nbsp;</span>Quay lại
          </button>
        </div>
      </div>
    </div>
    <!-- <b-breadcrumb :items="[
      {
        text: 'Home',
        href: '/'
      }, {
        text: 'Merchant owner',
        href: '#'
      }
    ]" /> -->

    <b-card>
      <!-- <template #header>
        <ul class="report-preview">
          <li>
            <div class="label">Liên hệ</div>
            <div class="value">{{ info && info.collapse && info.collapse.contacts || 0 }}</div>
          </li>
          <li>
            <div class="label">Thiết bị</div>
            <div class="value">{{ info && info.collapse && info.collapse.deviceStores || 0 }}</div>
          </li>
          <li>
            <div class="label">Nhân viên</div>
            <div class="value">{{ info && info.collapse && info.collapse.storeStaffs || 0 }}</div>
          </li>
        </ul>
      </template> -->

      <b-row class="gx-2">
        <b-col md="2">
          <MenuInner
            :activeItem="activeItem"
            :DetailMenus="DetailMenus"
            :id="id"
            :maId="id"
            :maName="info.storeName"
          >
          </MenuInner>
        </b-col>
        <b-col md="10">
          <b-row>
            <b-col cols="10" md="6">
              <DetailInfo :info="info" :isLoading="isLoading" :fields="keyNames">
                <!-- <template #id="{ value }">
                  <strong>{{ value }}</strong>
                </template> -->
                <!-- <template #accountName="{ value }">
                  <b-link :href="`/list-mc/${info.customerId}`" size="sm" target="_blank"> {{ value || '' }} </b-link>
                </template> -->
                <template #address>
                  <div>{{ getAdressByCode(info) }}</div>
                </template>
                <template #mapLocation>
                  <div>
                    <b-icon icon="geo-alt"></b-icon>
                    <strong
                      class="text-primary"
                      style="cursor: pointer"
                      @click="showMapModal(info.latitude, info.longitude, getAdressByCode(info))"
                      >{{ info.address }}</strong
                    >
                  </div>
                </template>
                <template #status="{ value }">
                  <span v-if="value" :class="`badge ${getStatusClass(value)}`">
                    {{ getStatusName(value) }}
                  </span>
                </template>
                <template #storeState="{ value }">
                  <span v-if="value" :class="`badge ${getStoreStateClass(value)}`">
                    {{ getStoreSateName(value) }}
                  </span>
                </template>
                <template #maInfo>
                  <div>{{ maInfo.accountName }}</div>
                </template>
                <template #moInfo>
                  <div>
                    {{ (moInfo.ownerName || moInfo.masterName) ?? moInfo.email }}
                  </div>
                </template>
                <template #createdStoreDate="{ value }">
                  <div v-if="value">{{ value | formatDate('DD/MM/YYYY HH:mm:ss') }}</div>
                </template>
              </DetailInfo>

              <div class="form-detail">
                <h1>
                  <strong class="h1-strong">Người liên hệ</strong>
                  <!-- <span class="float-right"><b-button variant="outline-primary" class="btn-class">Sửa</b-button></span> -->
                </h1>
                <template v-if="!isLoading">
                  <template v-if="contact.length > 0">
                    <div
                      :class="
                        index > 0 ? 'form-group form-row border-store' : 'form-group form-row'
                      "
                      v-for="(data, index) in contact"
                      :key="data.email"
                    >
                      <div class="col-sm-12 border-row">
                        <label for="" class="col-sm-4 col-form-label">
                          <p class="float-left">Tên người liên hệ:</p>
                        </label>
                        <div class="col-sm-8">
                          <p>
                            {{ data.name }}
                          </p>
                        </div>
                      </div>
                      <div class="col-sm-12 border-row">
                        <label for="" class="col-sm-4 col-form-label">
                          <p class="float-left">Chức vụ:</p>
                        </label>
                        <div class="col-sm-8">
                          <p>
                            {{ data.role }}
                          </p>
                        </div>
                      </div>
                      <div class="col-sm-12 border-row">
                        <label for="" class="col-sm-4 col-form-label">
                          <p class="float-left">Số điện thoại:</p>
                        </label>
                        <div class="col-sm-8">
                          <p>
                            {{ data.mobile }}
                          </p>
                        </div>
                      </div>
                      <div class="col-sm-12 border-row">
                        <label for="" class="col-sm-4 col-form-label">
                          <p class="float-left">Email:</p>
                        </label>
                        <div class="col-sm-8">
                          <p>
                            {{ data.email }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="text-center text-info my-2">Không có dữ liệu</div>
                  </template>
                </template>
                <template v-else>
                  <div class="spinner-center">
                    <b-spinner class="align-middle" />
                  </div>
                </template>
              </div>
            </b-col>
            <b-col cols="10" md="6">
              <div class="form-detail">
                <h1>
                  <strong class="h1-strong">Ảnh chi nhánh</strong>
                </h1>

                <template v-if="!isLoading">
                  <template v-if="info.images?.length > 0">
                    <div class="img-list">
                      <ul v-viewer class="m-0">
                        <li class="p-1 item-img" v-for="(item, index) in info.images" :key="index">
                          <a href="javascript:void(0)">
                            <img :src="item" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </template>
                  <template v-else>
                    <div class="text-center text-info my-2">Không có dữ liệu</div>
                  </template>
                </template>
                <template v-else>
                  <div class="spinner-center">
                    <b-spinner class="align-middle" />
                  </div>
                </template>
              </div>
              <div class="form-detail">
                <h1>
                  <strong class="h1-strong">Ảnh giấy tờ xác minh</strong>
                </h1>

                <template v-if="!isLoading">
                  <template v-if="info.verificationImage?.length > 0">
                    <div class="img-list">
                      <ul v-viewer class="m-0">
                        <li
                          class="p-1 item-img"
                          v-for="(item, index) in info.verificationImage"
                          :key="index"
                        >
                          <a href="javascript:void(0)">
                            <img :src="item" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </template>
                  <template v-else>
                    <div class="text-center text-info my-2">Không có dữ liệu</div>
                  </template>
                </template>
                <template v-else>
                  <div class="spinner-center">
                    <b-spinner class="align-middle" />
                  </div>
                </template>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="10" md="6">
              <div class="form-detail">
                <div class="d-flex">
                  <h1>
                    <strong class="h1-strong">Thông tin khác</strong>
                  </h1>
                  <b-button
                    :disabled="!getSecondStaff.length || !hasRemovePerm"
                    style="width: 60px"
                    size="sm"
                    variant="light"
                    @click="openRemoveAoModal()"
                    >Gỡ gán</b-button
                  >
                </div>
                <template v-if="!isLoading">
                  <template v-if="info?.staffAssigns?.length">
                    <div class="form-group form-row">
                      <b-col sm="12" class="border-row align-items-baseline">
                        <label for="" class="col-sm-4 col-form-label mt-2">
                          <p class="">Nhân viên phát triển:</p>
                        </label>
                        <div class="col-sm-8">
                          <div v-if="getMainStaff">
                            <span class="text-muted">Chính</span>:
                            <b-link
                              :href="`/staff/detail/?id=${getMainStaff.staffId}`"
                              target="_blank"
                            >
                              {{ getMainStaff.staffName }}
                            </b-link>
                          </div>

                          <div v-if="getSecondStaff.length">
                            <div class="d-flex align-items-baseline">
                              <span class="text-muted mr-1">Phụ:</span>
                              <div class="list-scroll">
                                <div
                                  class="d-flex justify-content-between align-items-center mt-1"
                                  v-for="staff in getSecondStaff"
                                  :key="staff.id"
                                >
                                  <a
                                    style="cursor: pointer"
                                    :href="`/staff/detail/?id=${staff.staffId}`"
                                    target="_blank"
                                  >
                                    <span>{{ `${staff.staffName}` }}</span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </b-col>
                    </div>
                  </template>
                  <template v-else>
                    <div class="text-center text-info my-2">Không có dữ liệu</div>
                  </template>
                </template>
                <template v-else>
                  <div class="spinner-center">
                    <b-spinner class="align-middle" />
                  </div>
                </template>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    <b-modal ref="modal-map" centered hide-footer hide-header size="lg">
      <div>
        <GmapMap
          :center="{ lat: latitude, lng: longtitude }"
          :zoom="12"
          map-type-id="terrain"
          style="width: 100%; height: 500px"
        >
          <gmap-marker :position="{ lat: latitude, lng: longtitude }"></gmap-marker>
        </GmapMap>
      </div>
    </b-modal>
    <b-modal ref="map-address" centered hide-footer hide-header size="lg" style="z-index: 500">
      <div>
        <iframe loading="lazy" :src="url" height="500" style="width: 100%" frameborder="0"></iframe>
      </div>
    </b-modal>

    <RemoveAoModal
      ref="AoModal"
      :second-staff="getSecondStaff"
      :levelAssign="'STORE'"
      @loadData="loadData"
    />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { Detail } from '@/services/customer-support/store'
  import { Detail as MoDetail } from '@/services/customer-support/merchant-owner'
  import { Detail as MaDetail } from '@/services/customer-support/account'
  import { showMess } from '@/config/utils'
  import { List as ContactList } from '@/services/customer-support/contact'
  import DetailInfo from '@/components/cskh/DetailInfo'
  import { CommonService } from '@/services/common.service'
  // import { StaffService } from '@/services/staff.service'
  // import { SearchByCode } from '@/services/customer-support/location'
  import moment from 'moment'
  import { StoreState } from '@/constant/customerSupport'
  import RemoveAoModal from '@/pages/customer-support/cskh/account/components/RemoveAoModal.vue'
  import MenuInner from '@/pages/customer-support/cskh/account/components/MenuInner.vue'
  import { DetailMenus } from '@/pages/customer-support/cskh/store/components/constant'

  export default {
    components: {
      MenuInner,
      RemoveAoModal,
      DetailInfo,
    },
    data() {
      return {
        DetailMenus,
        activeItem: 'thong_tin_chung',
        isOpen: false,
        isLoading: false,
        isLoadingContract: false,
        latitude: 0.0,
        longtitude: 0.0,
        id: '',
        url: null,
        info: {},
        maInfo: {},
        moInfo: {},
        keyNames: [
          { key: 'storeName', label: 'Tên cửa hàng' },
          { key: 'moInfo', label: 'Merchant Owner' },
          { key: 'maInfo', label: 'Merchant Account' },
          { key: 'regionName', label: 'Vùng merchant' },
          { key: 'provinceName', label: 'Tỉnh/thành' },
          { key: 'districtName', label: 'Quận/huyện' },
          { key: 'mapLocation', label: 'Địa chỉ' },
          { key: 'status', label: 'Trạng thái hoạt động' },
          { key: 'createdStoreDate', label: 'Ngày tạo' },
          { key: 'storeState', label: 'Trạng thái cửa hàng' },
        ],
        storeStateOptions: StoreState,
        listStatus: [],
        maContact: [],
        moContact: [],
        storeContact: [],
        listContact: [],
        dataConfigMcc: [],
        contact: [],
        regionCode: '',
        provinceCode: '',
        districtCode: '',
        pagination: {
          queryString: '',
          sortField: 'createdDate',
          sortType: 'DESC',
          page: 1,
          total: 0,
          limit: 20,
        },
      }
    },

    filters: {},

    async created() {
      this.id = this.$router.currentRoute.params.id
      await this.configSystem()
    },

    mounted() {
      if (this.dataPermission.includes('CNPS_CSS_STORE_DETAIL')) {
        this.toggleSideBar()
        this.loadData()
      } else {
        this.$bvModal
          .msgBoxOk('Bạn không có quyền truy cập vào trang này', {
            title: 'Cảnh báo',
            // size: 'sm',
            // buttonSize: 'sm',
            okVariant: 'danger',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true,
          })
          .then(value => {
            // chuyển trang
            this.$router.replace('/')
          })
      }
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),

      getStatusName() {
        return status => {
          const objStatus = this.listStatus.find(s => s.id === status)
          return objStatus ? objStatus.text : status
        }
      },
      getStatusClass() {
        return status => {
          const objStatus = this.listStatus.find(s => s.id === status)
          return objStatus ? objStatus.bgColor : 'badge-primary'
        }
      },
      getStoreSateName() {
        return status => {
          const objStatus = this.storeStateOptions.find(s => s.id === status)
          return objStatus ? objStatus.text : status
        }
      },
      getStoreStateClass() {
        return status => {
          const objStatus = this.storeStateOptions.find(s => s.id === status)
          return objStatus ? objStatus.bgColor : 'badge-primary'
        }
      },
      getMaContractName() {
        return ma => {
          const objStatus = this.maContact.find(s => s.id === ma)
          return objStatus ? objStatus.text : ma
        }
      },
      getMoContractName() {
        return mo => {
          const objStatus = this.moContact.find(s => s.id === mo)
          return objStatus ? objStatus.text : mo
        }
      },
      getStoreContractName() {
        return store => {
          const objStatus = this.storeContact.find(s => s.id === store)
          return objStatus ? objStatus.text : store
        }
      },
      getMainStaff() {
        return this.info.staffAssigns && this.info.staffAssigns.length > 0
          ? this.info.staffAssigns.find(uInfo => uInfo.configType === 'MAIN')
          : undefined
      },
      getSecondStaff() {
        return this.info.staffAssigns && this.info.staffAssigns.length > 0
          ? this.info.staffAssigns.filter(uInfo => uInfo.configType === 'SECOND')
          : []
      },
      hasRemovePerm() {
        return this.dataPermission.includes('CNPS_CSS_STAFF_ASSIGN_REMOVE')
      },
      getBusinessTypeName() {
        return mcc => {
          const objStatus = this.dataConfigMcc.find(s => s.id === mcc)
          return objStatus ? objStatus.text : mcc
        }
      },
    },

    methods: {
      onUpdate() {
        this.$router.push(`/customer-support/store/${this.id}/edit`)
      },
      openRemoveAoModal() {
        this.$refs.AoModal.show()
      },
      ReturnToList() {
        this.$router.push(`/customer-support/store`)
      },
      async loadData() {
        try {
          this.isLoading = true
          const res = await Detail(this.id)
          const data = res.data
          this.info = {
            ...data,
            verificationImage: data.verificationImage || [],
          }
          this.regionCode = data.regionCode || ''
          this.provinceCode = data.provinceCode || ''
          this.districtCode = data.districtCode || ''

          data.merchantOwnerId && (await this.MoData(data.merchantOwnerId))
          data.merchantAccountId && (await this.MaData(data.merchantAccountId))

          const resContact = await ContactList({
            // count: true,
            // countStatus: true,
            // showMerchantAccount: true,
            // showStaffAssign: true,
            storeId: this.id,
            limit: this.pagination.limit,
            page: this.pagination.page,
            sort: {
              direction: 'DESC',
              properties: ['createdDate'],
            },
          })
          this.listContact = resContact.data?.listData || []
          this.SetContactData()
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.isLoading = false
        }
      },
      SetContactData() {
        const storeContacts = []
        let roleArr = []
        this.listContact.forEach(element => {
          element.storeContacts.forEach(el => {
            roleArr.push(this.getStoreContractName(el.role))
          })
          const roles = [...new Set(roleArr)]
          storeContacts.push({
            name: element.name,
            role: roles.join(', '),
            mobile: element.mobile,
            email: element.email,
          })
          roleArr = []
        })
        this.contact = storeContacts
      },
      async MoData(id) {
        if (id) {
          try {
            this.isLoading = true
            const res = await MoDetail(id)
            if (res.data) {
              this.moInfo = res.data
            }
          } catch (e) {
            showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
          } finally {
            this.isLoading = false
          }
        }
      },
      async MaData(id) {
        if (id) {
          try {
            this.isLoading = true
            const res = await MaDetail(id)
            this.maInfo = res.data
            if (res.data) {
              this.maInfo = res.data
            }
          } catch (e) {
            showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
          } finally {
            this.isLoading = false
          }
        }
      },
      formatDate(date) {
        if (!date) return
        return moment(date).format('DD/MM/YYYY')
      },
      formatHour(date) {
        if (!date) return
        return moment(date).format('HH:mm')
      },
      setActive(id) {
        this.activeItem = id
      },
      toggleSideBar() {
        this.$store.commit('dom/SET_SIDEBAR_STATUS', !this.isOpen)
      },
      showMapModal(lat, long, address) {
        if (lat && long) {
          this.latitude = Number.isInteger(this.latitude) ? lat : parseFloat(lat)
          this.longtitude = Number.isInteger(this.longtitude) ? long : parseFloat(long)
          this.$refs['modal-map'].show()
        } else {
          this.url = `https://maps.google.com/maps?q=${address}&output=embed`
          this.$refs['map-address'].show()
        }
      },
      getAdressByCode(item) {
        const addressArr = []
        if (item.districtName) {
          addressArr.push(item.districtName)
        }
        if (item.provinceName) {
          addressArr.push(item.provinceName)
        }
        if (item.regionName) {
          addressArr.push(item.regionName)
        }
        return addressArr.length > 0 ? addressArr.join(', ') : item.address
      },
      // lấy ngành hàng và dịch vụ
      configSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              this.listStatus = data.data.storeStatus.map(e => {
                return {
                  id: e.code,
                  text: e.name,
                  bgColor: e.bgColor,
                  class: e?.class ?? 'text-primary',
                }
              })
              this.listStatus.unshift({ id: 0, text: 'Tất cả' })
              this.maContact = data.data.maContact.map(item => {
                return {
                  id: item.code,
                  text: item.name,
                }
              })
              this.moContact = data.data.moContact.map(e => {
                return {
                  id: e.code,
                  text: e.name,
                }
              })
              this.storeContact = data.data.storeContact.map(e => {
                return {
                  id: e.code,
                  text: e.name,
                }
              })
              this.dataConfigMcc = data.data.businessFields.map(e => {
                return {
                  id: e.code,
                  text: e.name,
                }
              })
            }
          })
          .catch(error => console.error(error))
      },
    },
  }
</script>

<style scoped>
  .form-detail {
    min-height: 120px;
  }
  .breadcrumb {
    margin-bottom: 0;
  }

  .card-footer {
    background-color: #fff;
    border-top: none !important;
  }

  .box {
    border: 1px solid #ddd;
    border-radius: 5px;
  }

  ul.report-preview {
    padding-left: 0;
    display: flex;

    li {
      border: 1px solid #ddd;
      border-radius: 5px;
      width: 100px;
      min-width: 100px;
      height: 60px;
      cursor: pointer;
      /* text-align: center; */
      padding: 10px;

      &:hover {
        color: #f00;
        font-weight: 500;
      }

      .label {
        font-size: 14px;
        text-align: center;
      }

      .value {
        text-align: center;
        margin-top: 2px;
        font-size: 16px;
        font-weight: 600;
      }

      & + li {
        margin-left: 10px;
      }
    }
  }

  .spinner-center {
    display: flex;
    justify-content: center;
  }

  h1 {
    border-bottom: none;
  }

  .h1-strong {
    border-left: 3px solid #13569f;
    padding-left: 5px;
    font-size: larger;
  }

  .img_logo {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: 1px solid #ddd;
  }

  .btn-class {
    background-color: #edf6ff;
  }

  .btn-class:hover {
    background-color: #007bff;
  }

  .inner_menu {
    border-right: 1px solid #edf1fa;
  }

  .menu_li:hover {
    background-color: #268dfc;
    color: #fff;
    cursor: pointer;
  }

  .border-row {
    border-bottom: 2px dashed #edf1fa;
    display: flex;
    align-items: center;
  }

  .border-store {
    border-top: 1px solid #a7a7a7;
  }
</style>
<style>
  .td_class {
    min-width: 150px;
    max-width: 200px;
  }

  .owner_class {
    min-width: 120px;
    max-width: 220px;
  }

  .store_class {
    padding-bottom: 5px;
  }

  .b-table-sticky-header {
    min-height: 20vh;
  }
  .img-list {
    position: relative;
    ul {
      .item-img {
        width: 108px;
        a {
          border: 2px solid #dcdcdc;
        }
        span {
          cursor: pointer;
          display: none;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        }
        &:hover span {
          display: block;
        }
      }
    }
  }
  .list-scroll {
    width: 100%;
    position: relative;
    height: 26vh;
    overflow-y: scroll;
  }

  .list-scroll::-webkit-scrollbar {
    width: 3px;
    border-radius: 2px;
  }

  .list-scroll::-webkit-scrollbar-thumb {
    background: #a8a8a8;
    border-radius: 2px;
  }
</style>
